import { useUser } from 'hooks/useUser';
import { PartnerFinanceMonthReport } from 'types/partnerFinance';

export const useUserPartnerFinanceMonthReports = (): PartnerFinanceMonthReport[] => {
  const user = useUser();

  return user?.partnerFinanceMonthReports || [];
};
